import { useTranslation } from "react-i18next";
import { Box, Center, Container, Image, Text } from "@mantine/core";
import { StepNavigationButtons } from "@/entities/StepNavigationButtons/StepNavigationButtons";
import { emailStepStore } from "@/entities/StepEmail/store/emailStepStore";
import { basePath } from "@/app/AppRoutes";
import { StepEmailInput } from "@/entities/StepEmail/StepEmailInput";
import { StepEmailPrivacy } from "@/entities/StepEmail/StepEmailPrivacy";
import { appStore, AuthMode } from "@/app/store/appStore";

import styles from "./stepEmail.module.scss";
import GoogleOAuthButton from "@features/GoogleOauth/ui/GoogleOAuthButton";
import FacebookOAuthButton from "@features/FacebookOauth/ui/FacebookOauthButton";
import SteamOpenIDButton from "@features/SteamOpenID/ui/SteamOpenidButton";
import { persistStore } from "@entities/StepFolder/store/persistStore";
import { STEPS_ENUM } from "@widgets/StepsManager/store/types";
import { stepsStore } from "@widgets/StepsManager/store/stepsStore";

export const StepEmail = () => {
	const { t } = useTranslation();
	const appCode = appStore((state) => state.appCode);
	const error = emailStepStore((state) => state.error);
	const startRequest = emailStepStore((state) => state.startRequest);
	const email = emailStepStore((state) => state.email);
	const hint = emailStepStore((state) => state.hint);
	const valueError = emailStepStore((state) => state.valueError);
	const isPrivacy = persistStore((state) => state.isPrivacy);
	const otherLogins = persistStore((state) => state.otherLogins);
	const authMode = appStore((state) => state.authMode);

	function handleNextButton() {
		startRequest();
	}
	function handleBackButton() {
		stepsStore.getState().setActiveStep(STEPS_ENUM.LoginSelectStep);
	}

	const nextBtnDisabled = !!error || !email || !isPrivacy || !!valueError;

	return (
		<Container className={styles.modalWrapper}>
			<Box className={styles.wrapper}>
				<Image id={`${appCode}_email`} src={`${basePath}${appCode}/email.svg`} alt="email" />
				<Text className={styles.description}>{t("stemEmail.stepDescription")}</Text>
				<StepEmailInput handleNextButton={handleNextButton} />

				<Text variant='error'>{valueError}&nbsp;</Text>
				<Text variant='hint'>{hint}</Text>
				<StepEmailPrivacy />
				{error && <Text variant='error' >{error}</Text>}
			</Box>
			<StepNavigationButtons
				backText={otherLogins.length>0 ? t("common.choose","Choose") : null}
				backOnClick={handleBackButton}
				backIsDisabled={!isPrivacy}
				nextText={t("common.login")}
				nextOnClick={handleNextButton}
				nextIsDisabled={nextBtnDisabled}
			/>
			{authMode !== AuthMode.oauth && (
				<Center pt={"md"}>
					<GoogleOAuthButton></GoogleOAuthButton>
					<FacebookOAuthButton></FacebookOAuthButton>
					<SteamOpenIDButton></SteamOpenIDButton>
				</Center>
			)}
		</Container>
	);
};
